import { user } from 'ampersand-app'
import config from '@/config'
import { VAT_CODES } from '@/enums/vat'

export interface Vat {
  value: number;
  name: string;
  vatCode: string;
}

const getVat1Germany = () => {
  const vatList = user.getVatListByDate(new Date(), { countryCode: config.defaultCountryAsISO2 }) as Vat[]
  return vatList?.find(vat => vat.vatCode === VAT_CODES.VAT1)
}

export default getVat1Germany
